import { Campaigns } from "../modules/campaigns";

export const CampaignsPage = () => {
  return <Campaigns />;
};
